import React, { useEffect, useRef, forwardRef } from 'react';

type MessageBoxProps = {
  value?: string;
  onChange: (changes: any | undefined) => void;
  placeholder?: string;
  limit?: number;
  button?: React.ReactNode;
};

const MessageBox = forwardRef<HTMLDivElement, MessageBoxProps>(
  (
    { value, onChange, placeholder = 'Write a message here...', limit, button },
    ref,
  ) => {
    const textAreaRef = useRef<HTMLTextAreaElement | null>(null);
    const updateNoteEditorHeight = () => {
      if (!textAreaRef.current) return;
      textAreaRef.current.style.height = '1px';
      textAreaRef.current.style.height =
        textAreaRef.current.scrollHeight + 2 + 'px';
    };

    useEffect(updateNoteEditorHeight, [value]);

    return (
      <div ref={ref} onClick={() => textAreaRef.current?.focus()} className="">
        <div
          className={`text-sm relative flex w-full items-start rounded-xl resize-none bg-gray-light-10 focus:outline-none `}
        >
          <div className="flex-1 flex max-h-44 py-2 overflow-y-auto">
            <textarea
              ref={textAreaRef}
              maxLength={limit}
              rows={1}
              className={`relative flex-1 px-4 text-gray-dark rounded-xl resize-none placeholder-gray-light bg-gray-light-10 focus:outline-none `}
              placeholder={placeholder}
              onChange={(e) => {
                const trimmed = e.target.value
                  .trimLeft()
                  .replace('\n\n\n', '\n\n');

                onChange(trimmed);
              }}
              value={value}
              onInput={updateNoteEditorHeight}
            ></textarea>
          </div>

          <div className="flex items-center mr-6 my-2">
            {limit && (
              <div className="mr-4 text-gray-light text-xs">
                {limit - (value ? value.length : 0)} / {limit}
              </div>
            )}
            {button}
          </div>
        </div>
      </div>
    );
  },
);

export default MessageBox;
